// src/services/contractCompiler.js
import api from './api';

export const compileContracts = async (sources, contractName = 'Factorylevel1') => {
  const response = await api.post('/smart_contract_insert/compile', {
    sources,
    contract_name: contractName,
  });
  return response.data;
};